import { useLayoutEffect } from "react";

/**
 * Component that forces a full page reload to the current URL.
 * Used for legacy paths that need to be served by the .NET backend.
 */
export function FullPageReload() {
    useLayoutEffect(() => {
        window.location.reload();
    }, []);

    return null;
}
